import { Typography, Box, Grid, Chip, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import React from "react";
import { nanoid } from "nanoid";

import MightyDataGrid from "../../../../components/organisms/MightyDataGrid";
import LabelEditDialog from "./LabelEditDialog";
import useLabels from "../../../../hooks/useLabels";
import ReorderDialog from "./ReorderDialog";
import { consola } from "consola";

import useEvents from "../../../../hooks/useEvents";
import EmptyLabels from "./EmptyLabels";

const EditLabels = () => {
  const { labels, loading, editLabelData, deleteLabelData, orderLabels } =
    useLabels({ adminDraftMode: true });
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [reorderDialogOpen, setReorderDialogOpen] = React.useState(false);
  const events = useEvents();

  const selectedLabel = React.useRef();

  const onEdit = (item) => {
    selectedLabel.current = item;
    setDialogOpen(true);
  };

  const onDelete = (item) => {
    deleteLabelData(item.id);
  };

  const columns = React.useMemo(() => {
    return [
      {
        field: "name",
        headerName: "Name",
        headerAlign: "left",
        align: "left",
        flex: 1,
        minWidth: 320,
        type: "string",
        hideable: false,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Chip
              variant="outlined"
              style={{
                color: params.row.color,
                borderWidth: 2,
                borderColor: params.row.backgroundColor,
                marginRight: 6,
              }}
              label={params.row.name}
            />
          );
        },
      },
    ];
  }, []);

  return (
    <>
      {/* Show empty state only after loading and when there are no labels */}
      {loading ? (
        <Box style={{ margin: 24, textAlign: "center" }}>
          <Typography>Loading...</Typography>
        </Box>
      ) : !labels || labels.length === 0 ? (
        <EmptyLabels
          onAddLabel={() => {
            selectedLabel.current = null;
            setDialogOpen(true);
          }}
        />
      ) : (
        <>
          <Box style={{ marginBottom: 54 }}>
            <Grid container style={{ marginTop: 4 }}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 20, fontWeight: "500", marginBottom: 12 }}
                >
                  Labels
                </Typography>
                <Typography
                  style={{
                    fontSize: 16,
                    fontWeight: "normal",
                    marginBottom: 12,
                  }}
                >
                  Labels are used throught the system to organize and filter.
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Stack
                  direction={"row"}
                  spacing={3}
                  justifyContent={"flex-end"}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent={"flex-end"}
                  >
                    <StandardButton
                      style={{ marginTop: 12 }}
                      variant="primary"
                      onClick={() => {
                        selectedLabel.current = null;
                        setReorderDialogOpen(true);
                        const reorderLabelEvent = {
                          buttonName: "Reorder Labels",
                          pageName: "Admin",
                          tabName: "Labels ",
                        };
                        events.logButtonClick(reorderLabelEvent);
                      }}
                    >
                      Reorder Labels
                    </StandardButton>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent={"flex-end"}
                  >
                    <StandardButton
                      style={{ marginTop: 12 }}
                      variant="primary"
                      onClick={() => {
                        selectedLabel.current = null;
                        setDialogOpen(true);
                        const addLabelEvent = {
                          buttonName: "Add Label",
                          pageName: "Admin",
                          tabName: "Labels ",
                        };
                        events.logButtonClick(addLabelEvent);
                      }}
                    >
                      Add Label
                    </StandardButton>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
            <Box style={{ margin: 12 }}>
              <MightyDataGrid
                entityName="labels"
                columns={columns}
                rows={labels}
                showActions={true}
                actionConfig={{
                  onEdit: onEdit,
                  onDelete: onDelete,
                  entityName: "Label",
                  pageName: "Admin",
                  tabName: "Labels",
                }}
              />
            </Box>
          </Box>
        </>
      )}

      {/* Dialogs - Always rendered regardless of empty state */}
      <LabelEditDialog
        open={dialogOpen}
        label={selectedLabel.current}
        onDialogClosed={async (data, label) => {
          if (!data && !label) {
            setDialogOpen(false);
            return;
          }
          setDialogOpen(false);

          if (data && label) {
            label.name = data.name;
            label.color = data.color;
            label.backgroundColor = data.backgroundColor;
            label.updatedOn = new Date();

            editLabelData(label);
          } else {
            const newLabel = {
              id: nanoid(),
              name: data.name,
              color: data.color,
              backgroundColor: data.backgroundColor,
              createdOn: new Date(),
              updatedOn: new Date(),
              index: labels.length,
            };

            editLabelData(newLabel);
          }
        }}
      />
      <ReorderDialog
        open={reorderDialogOpen}
        reorderTitle={"Reorder Labels"}
        list={labels}
        onDialogClosed={async (data) => {
          if (!data) {
            consola.log("Not saving labels :(");
            setReorderDialogOpen(false);
            return;
          }
          setReorderDialogOpen(false);
          if (data) {
            consola.log("saving labels!");
            orderLabels(data);
          }
        }}
      />
    </>
  );
};
export default EditLabels;
